export const QUIZMAKER_PAGE_DESCRIPTION = `
Prepare short quizzes on any topic.
You may also upload your own instructional material to create a quiz from it.`;
export const QUIZMAKER_PAGE_SUBLABEL_ENG = `Upload a PDF file (up to 2MB) as additional reference in generating questions`;
export const QUIZMAKER_PAGE_SUBLABEL_FIL = `Mag-upload ng PDF file at gagawa kami ng mga tanong mula rito`;
